import { askInputSubmitButtonClickedEvent } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/submission-policy/analytics.js';
/** Resolves the legacy right-attribution button gate and its attempt analytics. */
export function resolveAskInputSubmitButtonPolicy({ gateSearchModeSelection, getPreferredSearchModelForSearchMode, hasAttachments, isFollowUp, querySource, selectedSearchMode, showStopButton, skipSearchModeGate, }) {
    const searchModel = getPreferredSearchModelForSearchMode(selectedSearchMode);
    const gated = !skipSearchModeGate && gateSearchModeSelection(searchModel);
    return {
        accepted: !gated,
        analyticsEvent: askInputSubmitButtonClickedEvent({
            name: 'ask input submit button clicked',
            data: {
                querySource,
                searchMode: selectedSearchMode,
                isFollowUp,
                hasAttachments,
                isStreaming: showStopButton,
                gated,
            },
        }),
    };
}
//# sourceMappingURL=submitButtonPolicy.js.map